export const userStatuses = [
  { name: 'Active', id: 'active' },
  { name: 'Not active', id: 'registered' },
  { name: 'Invited', id: 'invited' },
  { name: 'Not active', id: 'not_active' },
  { name: 'On verification', id: 'on_verification' },
]

export const userTypes = [
  { name: 'Clinician', id: 'clinician' },
  { name: 'Admin', id: 'ha_admin' },
  { name: 'Supervisor', id: 'ha_supervisor' },
  { name: 'QA', id: 'ha_qa' },
  { name: 'Scheduler', id: 'ha_scheduler' },
  { name: 'Approver', id: 'sa_approver' },
  { name: 'Admin', id: 'sa_admin' },
]

export const haUserRoleIds = {
  HA_SCHEDULER: 'ha_scheduler',
  HA_ADMIN: 'ha_admin',
  HA_SUPERVISOR: 'ha_supervisor',
  HA_QA: 'ha_qa',
}

export const haUserRoles = [
  { name: 'Scheduler', id: 'ha_scheduler' },
  { name: 'Admin', id: 'ha_admin' },
  { name: 'QA', id: 'ha_qa' },
  { name: 'Supervisor', id: 'ha_supervisor' },
  { name: 'Not specified', id: 'Not specified' },
]

export const saUserRoles = [
  { name: 'Approver', id: 'sa_approver' },
  { name: 'Admin', id: 'sa_admin' },
  { name: 'Not specified', id: 'Not specified' },
]

export const saUserRoleIds = {
  SA_APPROVER: 'sa_approver',
  SA_ADMIN: 'sa_admin',
}

export const GENDERS = [
  { name: 'Male', id: 'male' },
  { name: 'Female', id: 'female' },
  { name: 'Not specified', id: 'Not specified' },
]
